import IconDog from '@/components/IconDog'
import IconRoom from '@/components/IconRoom'
import IconSpa from '@/components/IconSpa'
import IconSwim from '@/components/IconSwim/IconSwim'
import IconUltraLuxury from '@/components/IconUltraLuxury'
import IconAllowCellPhones from '@/components/IconAllowCellPhones'

export const LOCATION_PANEL_LINKS = [
  {
    name: 'United States',
    items: [
      {
        name: 'Florida',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/g3p7db91iwwqchap7yin'
      },
      {
        name: 'California',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/wmx9pyln1hxhqzc96bde'
      },
      {
        name: 'Arizona',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/xpi0zvhhiqr4271zqnkq'
      },
      {
        name: 'Colorado',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/uw9jfhdckedmpsqdncqb'
      },
      {
        name: 'Texas',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/d1lwtfrjjozuafz5gr9d'
      },
      {
        name: 'New England',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/q6rmk0ye6s1otyg868fu'
      }
    ],
    topLocations: [
      {
        name: 'United States',
        link: '/united-states/',
        locations: [
          {
            name: 'Arizona',
            link: '/arizona/'
          },
          {
            name: 'California',
            link: '/california/'
          },
          {
            name: 'Florida',
            link: '/florida/'
          },
          {
            name: 'Midwest',
            link: '/midwest/'
          },
          {
            name: 'Texas',
            link: '/texas/'
          },
          {
            name: 'Nevada',
            link: '/nevada/'
          },
          {
            name: 'Utah',
            link: '/utah/'
          },
          {
            name: 'Virginia',
            link: '/virginia/'
          },
          {
            name: 'Colorado',
            link: '/colorado/'
          },
          {
            name: 'New Jersey',
            link: '/new-jersey/'
          }
        ]
      }
    ]
  },
  {
    name: 'Worldwide',
    items: [
      {
        name: 'Bali',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/g3p7db91iwwqchap7yin'
      },
      {
        name: 'Thailand',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/wmx9pyln1hxhqzc96bde'
      },
      {
        name: 'Spain',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/xpi0zvhhiqr4271zqnkq'
      },
      {
        name: 'Switzerland',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/q6rmk0ye6s1otyg868fu'
      },
      {
        name: 'South Africa',
        link: '',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_48,w_48/uw9jfhdckedmpsqdncqb'
      }
    ],
    topLocations: [
      {
        name: 'Canada',
        link: '/canada/',
        locations: [
          {
            name: 'British Columbia',
            link: '/british-columbia/'
          },
          {
            name: 'Ontario',
            link: '/ontario/'
          },
          {
            name: 'Montreal',
            link: '/montreal/'
          },
          {
            name: 'Calgary',
            link: '/calgary/'
          }
        ]
      },
      {
        name: 'Australia',
        link: '/australia/',
        locations: [
          {
            name: 'Queensland',
            link: '/queensland/'
          },
          {
            name: 'Victoria',
            link: '/victoria/'
          },
          {
            name: 'New South Wales',
            link: '/new-south-wales/'
          },
          {
            name: 'Sydney',
            link: '/sydney/'
          }
        ]
      },
      {
        name: 'Latin America',
        link: '/latin-america/',
        locations: [
          {
            name: 'Costa Rica',
            link: '/costa-rica/'
          },
          {
            name: 'Panama',
            link: '/panama/'
          },
          {
            name: 'Mexico',
            link: '/mexico/'
          },
          {
            name: 'Ecuador',
            link: '/ecuador/'
          }
        ]
      },
      {
        name: 'Europe',
        link: '/europe/',
        locations: [
          {
            name: 'United Kingdom',
            link: '/united-kingdom/'
          },
          {
            name: 'Spain',
            link: '/spain/'
          },
          {
            name: 'Switzerland',
            link: '/switzerland/'
          },
          {
            name: 'Greece',
            link: '/greece/'
          }
        ]
      },
      {
        name: 'Africa',
        link: '/africa/',
        locations: [
          {
            name: 'Tunisia',
            link: '/tunisia/'
          },
          {
            name: 'South Africa',
            link: '/south-africa/'
          },
          {
            name: 'Johannesburg',
            link: '/johannesburg/'
          },
          {
            name: 'Cape Town',
            link: '/cape-town/'
          }
        ]
      },
      {
        name: 'Asia',
        link: '/asia/',
        locations: [
          {
            name: 'Bali',
            link: '/bali/'
          },
          {
            name: 'India',
            link: '/india/'
          },
          {
            name: 'Malaysia',
            link: '/malaysia/'
          },
          {
            name: 'Thailand',
            link: '/thailand/'
          }
        ]
      }
    ]
  },
  {
    name: 'Amenities and Settings',
    groups: ['Treatment Services'],
    items: [
      {
        name: 'Ultra-Luxury',
        link: '/luxury/',
        image: IconUltraLuxury
      },
      {
        name: 'Pet Friendly',
        link: '/amenities/pet-friendly/',
        image: IconDog
      },
      {
        name: 'Allows Cell Phones',
        link: '/amenities/allow-cell-phones/',
        image: IconAllowCellPhones
      },
      {
        name: 'Pool',
        link: '/amenities/pool/',
        image: IconSwim
      },
      {
        name: 'Private Rooms',
        link: '/amenities/private-rooms/',
        image: IconRoom
      },
      {
        name: 'Wellness',
        link: '/approach/wellness/',
        image: IconSpa
      }
    ],
    settings: [
      {
        name: 'Beach',
        link: '/setting/beach/'
      },
      {
        name: 'Mountain',
        link: '/setting/mountain/'
      },
      {
        name: 'Tropical',
        link: '/setting/tropical/'
      }
    ]
  },
  {
    name: 'Levels of Care',
    treatmentServices: [
      {
        name: 'Detox',
        link: '/care/detox/'
      },
      {
        name: 'Residential Rehab',
        link: '/united-states/'
      },
      {
        name: 'Sober Living',
        link: '/care/sober-living/'
      },
      {
        name: 'Outpatient',
        link: '/care/outpatient/'
      },
      {
        name: 'Intensive Outpatient',
        link: '/care/intensive-outpatient-program/'
      },
      {
        name: 'Virtual',
        link: '/care/virtual/'
      },
      {
        name: 'In-Home',
        link: '/care/in-home/'
      }
    ]
  },
  {
    name: 'Insurance',
    items: [
      {
        name: 'Aetna',
        link: '/insurance/aetna/'
      },
      {
        name: 'Anthem',
        link: '/insurance/anthem/'
      },
      {
        name: 'Carelon Behavioral Health',
        link: '/insurance/carelon-behavioral-health/'
      },
      {
        name: 'BlueCross Blueshield',
        link: '/insurance/bluecross-blueshield/'
      },
      {
        name: 'Bright Health',
        link: '/insurance/bright-health/'
      },
      {
        name: 'CareFirst',
        link: '/insurance/carefirst/'
      },
      {
        name: 'Cigna',
        link: '/insurance/cigna/'
      },
      {
        name: 'ComPsych',
        link: '/insurance/compsych/'
      },
      {
        name: 'GuideWell',
        link: '/insurance/guidewell/'
      },
      {
        name: 'HealthNet',
        link: '/insurance/healthnet/'
      },
      {
        name: 'HealthPartners',
        link: '/insurance/healthpartners/'
      },
      {
        name: 'Highmark',
        link: '/insurance/highmark/'
      },
      {
        name: 'Humana',
        link: '/insurance/humana/'
      },
      {
        name: 'Intermountain Healthcare',
        link: '/insurance/intermountain-healthcare/'
      },
      {
        name: 'ITU Funds',
        link: '/insurance/itu-funds/'
      },
      {
        name: 'Kaiser Permanente',
        link: '/insurance/kaiser-permanente/'
      },
      {
        name: 'Medicaid',
        link: '/insurance/medicaid/'
      },
      {
        name: 'Medicare',
        link: '/insurance/medicare/'
      },
      {
        name: 'MHN',
        link: '/insurance/mhn/'
      },
      {
        name: 'Optum',
        link: '/insurance/optum/'
      },
      {
        name: 'Oscar',
        link: '/insurance/oscar/'
      },
      {
        name: 'Tricare',
        link: '/insurance/tricare/'
      },
      {
        name: 'Tufts Health',
        link: '/insurance/tufts-health/'
      },
      {
        name: 'United Healthcare',
        link: '/insurance/united-healthcare/'
      }
    ]
  }
]

export const TREATMENT_PANEL_LINKS = [
  {
    name: 'Conditions',
    items: [
      {
        name: 'Anxiety',
        link: '/condition/anxiety/'
      },
      {
        name: 'Burnout & Stress',
        link: '/condition/stress/'
      },
      {
        name: 'Co-Occurring Disorders',
        link: '/condition/co-occurring-disorders/'
      },
      {
        name: 'Depression',
        link: '/condition/depression/'
      },
      {
        name: 'Eating Disorders',
        link: '/condition/eating-disorders/'
      },
      {
        name: 'Gambling',
        link: '/condition/gambling/'
      },
      {
        name: 'Trauma',
        link: '/condition/trauma/'
      },
      {
        name: 'Alcohol',
        link: '/condition/alcohol/'
      },
      {
        name: 'Addiction',
        link: '/united-states/'
      }
    ]
  },
  {
    name: 'Treatment Methods',
    groups: ['Treatment Approach', 'Therapies'],
    treatmentApproach: [
      {
        name: 'Evidence-Based',
        link: '/approach/evidence-based/'
      },
      {
        name: 'Holistic',
        link: '/approach/holistic/'
      },
      {
        name: 'Wellness',
        link: '/approach/wellness/'
      },
      {
        name: '12 Step',
        link: '/approach/twelve-step/'
      }
    ],
    therapies: [
      {
        name: 'Art Therapy',
        link: '/therapies/art-therapy/'
      },
      {
        name: 'EMDR',
        link: '/therapies/eye-movement-desensitization-and-reprocessing/'
      },
      {
        name: 'Equine Therapy',
        link: '/therapies/equine-therapy/'
      },
      {
        name: 'Mindfulness-Based Cognitive Therapy',
        link: '/therapies/mbct/'
      }
    ]
  },
  {
    name: 'Clientele',
    groups: ['Specialized Programs by Patient Population'],
    group1: [
      {
        name: 'Women',
        link: '/clientele/women/'
      },
      {
        name: 'Children',
        link: '/clientele/children/'
      },
      {
        name: 'Executives',
        link: '/clientele/executives/'
      },
      {
        name: 'Men',
        link: '/clientele/men/'
      },
      {
        name: 'Teens',
        link: '/clientele/adolescents/'
      },
      {
        name: 'Veterans',
        link: '/clientele/veterans/'
      },
      {
        name: 'LGBTQ+',
        link: '/clientele/lgbtq/'
      },
      {
        name: 'Young Adults',
        link: '/clientele/young-adults/'
      },
      {
        name: 'Christians',
        link: '/approach/christian/'
      },
      {
        name: 'Pregnant Women',
        link: '/clientele/pregnant-women/'
      },
      {
        name: 'Older Adults',
        link: '/clientele/older-adults/'
      },
      {
        name: 'Couples',
        link: '/clientele/couples/'
      }
    ]
  },
  {
    name: 'Resource Hub',
    header: 'Resource Hub',
    text: 'Researched, fact-checked and transparent articles and guides that offer addiction and mental health insight from experts and treatment professionals.',
    button: 'Visit Our Resource Hub',
    link: '/resources/'
  }
]

export const LEARN_PANEL_LINKS = [
  {
    name: 'Resource Hub',
    header: 'Resource Hub',
    text: 'Researched, fact-checked and transparent articles and guides that offer addiction and mental health insight from experts and treatment professionals.',
    button: 'Visit Our Resource Hub',
    link: '/resources/'
  }
]

export const MOBILE_NAV_LINKS = [
  {
    label: 'United States',
    page: 'United States',
    container: 'United States'
  },
  {
    label: 'Worldwide',
    page: 'Worldwide',
    container: 'Worldwide'
  },
  {
    label: 'Amenities and Settings',
    page: 'Conditions',
    container: 'Amenities and Settings'
  }
]

export const ABOUT_NAV_LINKS = [
  {
    label: 'About Us',
    page: 'About',
    container: 'About Us',
    'aria-label': 'About Us'
  },
  {
    label: 'Our Criteria',
    page: 'About',
    container: 'Our Criteria'
  },
  {
    label: 'Careers',
    page: 'About',
    container: 'Careers'
  },
  {
    label: 'Contact Us',
    page: 'About',
    container: 'Contact Us'
  }
]
